export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/clue-e4eac0701ce3b49fffeab4dc73431b7b.png";